<template>
  <div v-if="project.project_id" class="font-inter space-y-5 p-8">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div class="space-y-4 bg-primaryBg p-3 rounded-[12px] min-w-full max-h-[400px] overflow-y-auto">
        <div class="flex justify-between items-center">
          <span class="flex items-center text-[14px] gap-2">
            <div class="w-2 h-2 bg-[#E0921E] rounded-full"></div>
            Not Started - {{ notStartedTasksCount }}                
          </span>
          <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </p>
        </div>
        <div 
          v-for="task in notStartedTasks"
          :key="task.task_id"
          @click="openSideMenu(task)"
          class="w-full border border-grayLight rounded-lg py-3 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray"
          draggable="true"
          @dragstart="handleDragStart(task)"
          @dragover.prevent
          @drop="handleDrop('Not Started')"
        >
        <div class="px-5 py-1 border-grayLight border-b-[1px] w-full">
          <h2 class="text-[15px] text-bodyText font-semibold">{{ task.title }}</h2>
        </div>
        <div class="px-5 flex space-x-2 text-[14px] text-grayDark items-center">
          <img src="@/assets/tasks/flag.svg" alt="Options" class="h-4 cursor-pointer" />
          <p>Priority</p>
        </div>
        <div class="px-5 flex justify-between w-full">
          <div class="flex items-center text-[13px] rounded-[8px] text-grayDark font-medium gap-2">
            <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
            {{ formatDate(task.due_date) }}
          </div>
        </div>
        </div>
      </div>     

      <div class="space-y-4 bg-primaryBg p-3 rounded-[12px] min-w-full max-h-[400px] overflow-y-auto">
        <div class="flex justify-between items-center">
          <span class="flex items-center text-[14px] gap-2">
            <div class="w-2 h-2 bg-[#53D65A] rounded-full"></div>
              In Progress - {{ inProgressTasksCount }}                
          </span>
          <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </p>
        </div>
        <div 
          v-for="task in inProgressTasks"
          :key="task.task_id"
          @click="openSideMenu(task)"
          class="w-full border border-grayLight rounded-lg py-3 px-5 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray"
          draggable="true"
          @dragstart="handleDragStart(task)"
          @dragover.prevent
          @drop="handleDrop('In Progress')"
        >
        <div class="px-5 py-1 border-grayLight border-b-[1px] w-full">
          <h2 class="text-[15px] text-bodyText font-semibold">{{ task.title }}</h2>
        </div>
          <div class="flex space-x-2 items-center text-grayDark text-[14px]">
            <img src="@/assets/tasks/flag.svg" alt="Options" class="h-4 cursor-pointer" />
            <p>Priority</p>
          </div>
          <div class="flex justify-between w-full">
            <div class="flex items-center text-[13px] rounded-[8px] text-grayDark font-medium gap-2">
              <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
              {{ formatDate(task.due_date) }}
            </div>
          </div>
        </div>
      </div> 

      <div class="space-y-4 bg-primaryBg p-3 rounded-[12px] min-w-full max-h-[400px] overflow-y-auto">
        <div class="flex justify-between items-center">
          <span class="flex items-center text-[14px] gap-2">
            <div class="w-2 h-2 bg-[#22C55E] rounded-full"></div>
              Done - {{ doneTasksCount }}                
          </span>
          <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </p>
        </div>
        <div 
          v-for="task in doneTasks"
          :key="task.task_id"
          @click="openSideMenu(task)"
          class="w-full border border-grayLight rounded-lg py-3 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray"
          draggable="true"
          @dragstart="handleDragStart(task)"
          @dragover.prevent
          @drop="handleDrop('Done')"
        >
          <div class="px-5 py-1 border-grayLight border-b-[1px] w-full">
            <h2 class="text-[15px] text-bodyText font-semibold">{{ task.title }}</h2>
          </div>
          <div class="px-5 flex space-x-2 text-[14px] text-grayDark items-center">
            <img src="@/assets/tasks/flag.svg" alt="Options" class="h-4 cursor-pointer" />
            <p>Priority</p>
          </div>
          <div class="px-5 flex justify-between w-full">
            <div class="flex items-center text-[13px] rounded-[8px] text-grayDark font-medium gap-2">
              <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
              {{ formatDate(task.due_date) }}
            </div>
          </div>
        </div>
      </div> 

      <div class="space-y-4 bg-primaryBg p-3 rounded-[12px] min-w-full max-h-[400px] overflow-y-auto">
        <div class="flex justify-between items-center">
          <span class="flex items-center text-[14px] gap-2">
            <div class="w-2 h-2 bg-[#22C55E] rounded-full"></div>
              Completed - {{ completedTasksCount }}                
          </span>
          <p @click="emitOpenCreateProjectModal" class="flex px-2 py-1 bg-[#EFF4FF] rounded-md">
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.5 9.5H13.5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 14V5" stroke="#222222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </p>
        </div>
        <div 
          v-for="task in completedTasks"
          :key="task.task_id"
          @click="openSideMenu(task)"
          class="w-full border border-grayLight rounded-lg py-3 space-y-4 flex flex-col justify-between items-start cursor-pointer bg-white-to-gray"
          draggable="true"
          @dragstart="handleDragStart(task)"
          @dragover.prevent
          @drop="handleDrop('Completed')"
        >
          <div class="px-5 py-1 border-grayLight border-b-[1px] w-full">
            <h2 class="text-[15px] text-bodyText font-semibold">{{ task.title }}</h2>
          </div>
          <div class="px-5 flex space-x-2 text-[14px] text-grayDark items-center">
            <img src="@/assets/tasks/flag.svg" alt="Options" class="h-4 cursor-pointer" />
            <p>Priority</p>
          </div>
          <div class="px-5 flex justify-between w-full">
            <div class="flex items-center text-[13px] rounded-[8px] text-grayDark font-medium gap-2">
              <img src="@/assets/projects/task-square.svg" alt="team" class="h-4 overlap" />
              {{ formatDate(task.due_date) }}
            </div>
          </div>
        </div>
      </div> 
    </div>
  </div>

  <div
      v-if="isSideMenuOpen"
      class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"
      @click="closeSideMenu"
    ></div>


  <div
      v-if="isSideMenuOpen"
      class="fixed top-0 right-0 w-[543px] h-full bg-white shadow-lg z-50 transform transition-transform duration-300 text-[14px]"
    >
      <!-- <div > -->
        <div class="space-y-4">
          <div class="py-4 px-4 flex justify-between items-center border-b-[1px] border-grayLight">
            <h3 class="text-lg font-medium">{{ selectedTask?.title }}</h3>
            <div class="flex space-x-2 items-center">
              <!-- <img src="@/assets/tasks/paperclip.svg" alt="Options" class="h-6 cursor-pointer" /> -->
              <!-- <img src="@/assets/projects/options.svg" alt="Options" class="h-6 cursor-pointer" /> -->
              <div @click="closeSideMenu" class="bg-[#FAFBFC] h-8 rounded-full flex items-center justify-center">
                <img src="@/assets/tasks/iconoir_cancel.svg" alt="Options" class="h-6 cursor-pointer" />
              </div>
            </div>          
          </div>
          <!-- <hr class="w-full border-t border-grayLight rounded-full"> -->


        </div>
          <div class="px-5 py-4 border-grayLight border-b-[1px] space-y-4">
            <StatusComponent v-if="!isUser" @status-changed="filterProjectsByStatus" />
          </div>
        <div class="px-5 py-4 border-grayLight border-b-[1px] space-y-4 text-grayDark text-[13px]">
          <div class="space-y-3">
            <div class="flex space-x-[68px] item-center text-[13px]">
              <div class="flex w-[88px] space-x-2 items-center">
                <img src="@/assets/tasks/status.svg" alt="Options" class="h-4 cursor-pointer" />
                <p>Status</p>
              </div>
              <div class="flex space-x-4">
                <div class="flex items-center space-x-3">
                  <span class="flex items-center text-[13px] font-medium gap-2">
                    <div class="w-[6px] h-[6px] bg-[#E0921E] rounded-full"></div>
                    Not Started - {{ notStartedTasks.length }}
                  </span>
                  <img
                    :src="notStartedTasksDropdownVisible ? require('@/assets/projects/Vector.svg') : require('@/assets/projects/Vector.svg')"
                    alt="Toggle"
                    class="w-2 h-3"
                  />               
                </div>  
                <p class="flex items-center cursor-pointer gap-2 rounded-[6px] bg-[#FFFFFF] bg-[14px] px-2 py-1 border border-grayLight">
                  <img src="@/assets/tasks/tick-circle.svg" alt="Options" class="h-4 cursor-pointer" />
                    Mark as complete
                </p>                 
              </div>
            </div>  
            <div class="flex space-x-[68px] item-center">
              <div class="flex w-[88px] space-x-2 items-center">
                <img src="@/assets/tasks/user.svg" alt="Options" class="h-4 cursor-pointer" />
                <p>Asignees</p>
              </div>
                <img src="@/assets/tasks/tick-circle.svg" alt="Options" class="h-4 cursor-pointer" />
            </div>
            <div class="flex space-x-[68px] item-center">
              <div class="flex w-[88px] space-x-2 items-center">
                <img src="@/assets/tasks/calendar-2.svg" alt="Options" class="h-4 cursor-pointer" />
                <p>Date</p>
              </div>
              <span class="">{{ formatDate(selectedTask?.due_date) }}</span>
            </div>  
            <div class="flex space-x-[68px] item-center">
              <div class="flex w-[88px] space-x-2 items-center">
                <img src="@/assets/tasks/flag.svg" alt="Options" class="h-4 cursor-pointer" />
                <p>Priority</p>
              </div>
              <span class="">{{ selectedTask?.priority }}</span>
            </div>
            <div class="flex space-x-10 item-center">
              <div class="flex w-[115px] space-x-2 items-center">
                <img src="@/assets/tasks/timer.svg" alt="Options" class="h-4 cursor-pointer" />
                <p>Estimated time</p>
              </div>
              <span class="">Empty</span>
            </div>
          </div>
        </div>

      <!-- </div> -->
      <div class="p-4 space-y-4">
        <div class="">
          <label class="block text-[13px] font-medium text-gray-700">Description</label>
          <textarea v-model="selectedTask.description" placeholder="Enter task description" class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required></textarea>
        </div> 
      </div>
    </div>

</template>

<script>
import apiClient from "@/axios";
import StatusComponent from "../dashboard/StatusComponent.vue";

export default {
  name: "TaskTableComponent",
  components: {
    StatusComponent
  },
  data() {
    return {
      isSideMenuOpen: false,
      inProgressTasksDropdownVisible: true,
      completedTasksDropdownVisible: false,
      doneTasksDropdownVisible: false,
      notStartedTasksDropdownVisible: false,
      project: {
        project_id: "",
        project_name: "",
        description: "",
        start_date: "",
        end_date: "",
      },
      tasks: [],
      draggedTask: null, // Track the dragged task
    };
  },
  watch: {
  '$route.params.projectId': {
    immediate: true,
    handler(newProjectId) {
      if (newProjectId) {
        this.fetchProject();
      }
    }
  }
},
  computed: {
    inProgressTasks() {
      return this.tasks.filter((task) => task.task_status === "In Progress");
    },
    completedTasks() {
      return this.tasks.filter((task) => task.task_status === "Completed");
    },
    notStartedTasks() {
      return this.tasks.filter((task) => task.task_status === "Not Started");
    },
    notStartedTasksCount() {
    return this.tasks.filter(task => task.task_status === 'Not Started').length;
    },
    inProgressTasksCount() {
      return this.tasks.filter(task => task.task_status === 'In Progress').length;
    },
    completedTasksCount() {
      return this.tasks.filter(task => task.task_status === 'Completed').length;
    },
    doneTasks() {
      return this.tasks.filter((task) => task.task_status === "Done");
    },
    doneTasksCount() {
      return this.tasks.filter((task) => task.task_status === "Done").length;
    },
  },
  methods: {
    openSideMenu(task) {
      this.selectedTask = task; // Set the selected task
      this.isSideMenuOpen = true; // Open the side menu
    },
    closeSideMenu() {
      this.isSideMenuOpen = false; // Close the side menu
      this.selectedTask = null; // Clear the selected task
      this.showSuccess = "";
      this.successMessage = "";
      this.errorMessage = "";     
    },
    toggleInProgressTaskDropdown() {
      this.inProgressTasksDropdownVisible = !this.inProgressTasksDropdownVisible;
    },
    toggleCompletedTaskDropdown() {
      this.completedTasksDropdownVisible = !this.completedTasksDropdownVisible;
    },
    notStartedTaskDropdown() {
      this.notStartedTasksDropdownVisible = !this.notStartedTasksDropdownVisible;
    },
    toggleDoneTasksDropdown() {
      this.doneTasksDropdownVisible = !this.doneTasksDropdownVisible;
    },
    formatDate(dateString) {
      if (!dateString) return "No Due Date";
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },
    async fetchProject() {
      const projectId = this.$route.params.projectId;
      try {
        const response = await apiClient.get(`/web/projects/${projectId}`);
        this.project = response.data.data;
        this.fetchTasks(projectId);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.$router.push({ name: "NotFound" });
        } else {
          console.error("Error fetching project:", error);
        }
      }
    },
    async fetchTasks(projectId) {
      try {
        const response = await apiClient.get(`/web/projects/${projectId}/tasks`);
        this.tasks = response.data.data;
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }
    },
    handleDragStart(task) {
      this.draggedTask = task;
    },
    handleDrop(status) {
      if (this.draggedTask) {
        this.draggedTask.task_status = status;
        this.updateTaskStatus(this.draggedTask);
        this.draggedTask = null;
      }
    },
    async updateTaskStatus(task) {
      try {
        await apiClient.put(`/web/tasks/${task.task_id}?project_id=${this.project.project_id}`, { task_status: task.task_status });
        this.fetchTasks(this.project.project_id);
      } catch (error) {
        console.error("Error updating task status:", error);
      }
    },
  },
  created() {
    this.fetchProject();
  },
};
</script>



<style scoped>
.fixed {
  transition: transform 0.3s ease-in-out;
}
.fixed[style*="transform: translateX(0%)"] {
  transform: translateX(0%);
}
.fixed[style*="transform: translateX(100%)"] {
  transform: translateX(100%);
}
</style>
